import { ApiUrl } from "../../../assets/data/TkApiUrlProperty";
import http from "../../../services/http";
import {
  IAPI_CON001_Request,
  IAPI_CON001_Response,
  IAPI_TEM003_Request,
  IAPI_TEM003_Response,
} from "../../../type/apiType";

/**
 * メールテンプレート更新API
 * @return httpAPI_TEM003
 */
const httpAPI_TEM003 = async (
  param: IAPI_TEM003_Request
): Promise<IAPI_TEM003_Response> => {
  let res = await http.post(ApiUrl.API_TEM003, {
    ...param,
  });

  return res.data;
};

/**
 * 契約者一覧参照API
 * @return httpAPI_CON001
 */
const httpAPI_CON001 = async (
  param: IAPI_CON001_Request
): Promise<IAPI_CON001_Response> => {
  let res = await http.post(ApiUrl.API_CON001, {
    ...param,
  });

  return res.data;
};

export { httpAPI_TEM003, httpAPI_CON001 };
